import { restClient } from '@/Core'

/** One driver/vehicle pair — becomes a single standalone task. */
export interface BatchAssignmentRow {
    driver: string | null
    vehicle: string | null
}

export interface CreateStandaloneAssignmentBatchPayload {
    /** Fields common to every created task (IRIs / scalars). */
    shared: Record<string, any>
    /** One entry per created task. */
    assignments: BatchAssignmentRow[]
}

/**
 * Множинне створення standalone-задач одним запитом. Бекенд для кожної пари
 * створює окрему задачу зі статусом «Призначено виконавець» та шле сповіщення
 * водієві (див. ExecutorAssignmentBatchController).
 */
export const CreateStandaloneAssignmentBatchTask = async (
    payload: CreateStandaloneAssignmentBatchPayload
): Promise<any> => {
    return restClient.post('/services/executor-assignments/batch', { json: payload })
}
